import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=e16b55f8&scoped=true&"
import script from "./PaymentLink.vue?vue&type=script&lang=js&"
export * from "./PaymentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16b55f8",
  null
  
)

export default component.exports